import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { IAdminConfig } from '@models/admin-config';
import { Table } from '@models/table';
import { sleep } from '@utils/promise';

let _initResolve: (value: boolean) => void;
const _initPromise: Promise<boolean> = new Promise(
  resolve => (_initResolve = resolve)
);

@Injectable({
  providedIn: 'root'
})
export class AdminConfigService {
  private _data: IAdminConfig = null;
  private pageDescription: string = null;
  private pageTitle: string = null;
  private tables: Table[] = null;

  constructor(private http: HttpClient, private translate: TranslateService) {
    this.init();
  }

  private async init(): Promise<void> {
    let resolveValue = false;
    try {
      this._data = await this.http
        .get<IAdminConfig>('assets/config.json')
        .toPromise();

      this.tables = this._data.tables.map((_: any) => new Table(_));
      this.pageDescription = this._data.pageDescription;
      this.pageTitle = this._data.pageTitle || 'Admin Dashboard';

      this.translate.onLangChange.subscribe(
        () => (document.title = this.translate.instant(this.pageTitle))
      );

      resolveValue = true;
    } catch (e) {
      console.error('AdminConfigService.init()::catch', e);
    }

    await sleep(300);
    _initResolve(resolveValue);
  }

  public getPageDescription(): string {
    return this.pageDescription;
  }

  public getPageTitle(): string {
    return this.pageTitle;
  }

  public getTables(): Table[] {
    return this.tables;
  }

  public getTableByName(name: string): Table {
    return this.tables.find(_ => _.getName() === name);
  }

  public async onInit(): Promise<boolean> {
    return await _initPromise;
  }
}
